import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Header from "../common/Header";
import CheckmarkLarge from "../../assets/CheckmarkLarge";
import * as actions from "../../state/actions";
import SSNInput from "../common/SSNInput";
import { track } from "../../api/heap";

const steps = [
  "basicinfo",
  "verifyphone",
  "address",
  "personalinformation",
  "verifyid",
  "linkbank",
  "student",
  "confirm"
];

class ResumeApplication extends Component {
  constructor(props) {
    super(props);
    this.state = {
      valid: false,
      error: null
    };
  }

  static propTypes = {
    history: PropTypes.object.isRequired
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.user.email) {
      this.setState({ valid: true });
      window.sessionStorage.setItem("userId", nextProps.user.email);
      if (nextProps.phoneNumberVerified) {
        this.setState({ nextPath: "address" });
      }
      // Disable the timeout for now
      // if (!this.timeout) {
      //   this.timeout = setTimeout(() => {
      //     this.timeout = null;
      //     this.props.history.push(this.resumeStepPath());
      //   }, 8000);
      // }
    }
  }

  async componentDidMount() {
    const {
      applicationProgress,
      user: { email },
      history: { push },
      hydrateStateWithToken,
    } = this.props;

    const params = this.searchParams();
    const userParams = params.user
    const jwt = localStorage.getItem("jwt");
    const userId = userParams ? decodeURIComponent(userParams) : email;

    if (!Object.keys(applicationProgress || {}).length) {
      console.log("ResumeApplication has no applicationProgress");
      if (jwt || userId) {
        console.log(
          "ResumeApplication has enough data to hydrate state. Hydrating..."
        );
        await hydrateStateWithToken({
          jwt,
          email: userId,
        });
      } else {
        console.log(
          "ResumeApplication does not have enough data to hydrate state! Pushing to /login"
        );
        if (jwt) localStorage.removeItem("jwt");
        push("/login");
      }
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  handleNext = () => {
    const {
      props: {
        user: { email } = {},
        updateUserDatabase,
        history: { push },
        applicationProgress: { hasResumed }
      },
      resumeStepPath
    } = this;
    track("ONBOARDING_RESUME_APPLICATION_RESUME_BUTTON_CLICKED");
    if (!hasResumed) {
      updateUserDatabase(email, {
        applicationProgress: { hasResumed: true }
      });
    }
    push(resumeStepPath());
  };

  searchParams = () =>
    window.location.search
      .slice(1)
      .split("&")
      .reduce((a, c) => ({ [c.split("=")[0]]: c.split("=")[1], ...a }), {});

  resumeStepPathOld = () => {
    const {
      applicationProgress: { lastCompletedStep } = {},
      user: { email: userId, applicationStatus, evaluationComplete }
    } = this.props;
    let path;
    if (lastCompletedStep >= steps.length - 1) {
      console.log("User may have already submitted the application");
      const uploadDocs = applicationStatus === "pending" && !evaluationComplete;
      if (uploadDocs) path = `/verifyiddocs`;
      else path = `/${steps[steps.length - 1]}`;
    } else {
      path = `/${steps[lastCompletedStep + 1 || 1]}`;
    }

    return path + `?user=${userId}`;
  };

  firstIncomplete = () => {
    const {
      applicationProgress: {
        basicInfo,
        verifyPhone,
        address,
        personalInformation,
        verifyId,
        linkBank,
        student,
        confirm,
        lastCompletedStep
      } = {}
    } = this.props;

    const stepStatuses = [
      basicInfo,
      verifyPhone,
      address,
      personalInformation,
      verifyId,
      linkBank,
      student,
      confirm
    ];
    const firstNull = stepStatuses.indexOf(null);
    const firstFalse = stepStatuses.indexOf(false);
    const values = [firstNull, firstFalse].filter(x => x > 0);
    if (!values.length) {
      console.log(
        "ResumeApplication firstIncomplete - ALL steps are complete. This can happen if the user has application_status 'preapproved'. Sending step 7."
      );
      return 7;
    }
    const firstIncomplete = Math.min(...values);
    return firstIncomplete >= 0 ? firstIncomplete : 7;
  };

  resumeStepPath = () => {
    const {
      applicationProgress: { lastCompletedStep } = {},
      user: { email: userId, applicationStatus, evaluationComplete }
    } = this.props;
    let path;
    const firstIncomplete = this.firstIncomplete();
    const uploadDocs = applicationStatus === "pending" && !evaluationComplete;
    const uploadDocsDone = lastCompletedStep >= 8;
    if (steps[firstIncomplete] === "verifyid") {
      // there is no "/verifyid" path; there is only /processingidentity
      // send user to step right before
      path = `/${steps[firstIncomplete - 1]}`;
      console.log(
        "exception made for path, using",
        steps[firstIncomplete - 1],
        "instead of",
        steps[firstIncomplete]
      );
    } else if (uploadDocs && !uploadDocsDone) {
      path = `/verifyiddocs`;
    } else {
      path = `/${steps[firstIncomplete]}`;
    }
    return path + `?user=${userId}`;
  };

  resendEmail = async () => {
    const {
      verificationEmailSend,
      user: { email }
    } = this.props;

    let emailAddress = email;

    this.setState({ error: null, networkingError: null });

    if (!email) {
      const search = this.props.history.location.search;
      const params = search.replace("?", "").split("&");
      const f = params.filter(p => {
        if (p.substring(0, 5) === "user=") {
          return true;
        }
        return false;
      });

      if (f.length) {
        emailAddress = f[0].substring(5, f[0].length);
      }

      if (!emailAddress) {
        this.setState({
          error: "URL invalid. Check the link in your email again."
        });
        return;
      }
    }

    track("ONBOARDING_RESUME_APPLICATION_EMAIL_RESENT");
    verificationEmailSend(emailAddress);
    // We will want better error-handling: use any errors we have in Redux
    this.setState({ resent: true });
  };

  renderEmailVerified = () => {
    const { resendEmail, resumeStepPath, handleNext } = this;
    const { valid, error, resent } = this.state;
    const { networkingError } = this.props;
    track("ONBOARDING_RESUME_APPLICATION_EMAIL_VERIFIED");

    return (
      <div className="outerStack-mobile sm:outerStack">
        {error || networkingError ? (
          <div className="stepDescriptionText">Something went wrong.</div>
        ) : valid ? (
          <div className="stepDescriptionText">Email Verified!</div>
        ) : (
          <div className="stepDescriptionText">Checking...</div>
        )}
        <div className="innerStack">
          {valid && (
            <CheckmarkLarge
              className="m-auto"
              style={{ height: 100, paddingBottom: 30 }}
            />
          )}
          <div className="textContainer">
            {/* TODO: Have user log in if we cannot reload their application
           state. Issue a new rehydrate token or something. */}
            <div>
              {error || networkingError
                ? "We were unable to resume your application. Make sure to use the link you received in your email. The link is one-time use. Resend the email to get a new link."
                : valid
                ? "Thanks for verifying your email. Now, let's continue!"
                : "Please wait..."}
            </div>
            <br />
            {error ||
              (networkingError && (
                <div>
                  <span>
                    {resent
                      ? "Thanks! Please check your mail for the link."
                      : "Link didn't work? "}
                  </span>
                  {resent || (
                    <a onClick={resendEmail} style={{ color: "#24ebbc" }}>
                      Resend the Email
                    </a>
                  )}
                </div>
              ))}
          </div>
          <div>
            <input
              disabled={!valid}
              type="button"
              name="button"
              value="Continue Application"
              onClick={() => {
                handleNext();
              }}
              className="continueButton"
              style={{
                ...(valid || { backgroundColor: "gray" })
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  renderResumeApplication = () => {
    const {
      applicationProgress: p,
      user: { applicationStatus, evaluationComplete } = {}
    } = this.props;
    track("ONBOARDING_RESUME_APPLICATION", { step: p.lastCompletedStep });

    const uploadDocs = applicationStatus === "pending" && !evaluationComplete;
    const uploadDocsDone = (p || {}).lastCompletedStep >= 8;
    const displaySteps = [
      { key: "verifyPhone", text: "Verify Phone Number" },
      { key: "address", text: "Address" },
      { key: "personalInformation", text: "Personal Information" },
      { key: "verifyId", text: "Verify ID" },
      { key: "linkBank", text: "Link Bank" },
      { key: "student", text: "Are you a student?" },
      ...(uploadDocs
        ? [
            {
              key: "confirm",
              text: "Submit Application"
            },
            {
              key: "verifyiddocs",
              text: "Upload Documents"
            }
          ]
        : [])
    ];

    const done = "";
    const currentStep = "font-bold";
    const incomplete = "font-thin";
    const firstIncomplete = this.firstIncomplete() - 1;
    const check = () => <i className="far fa-solid fa-check text-primary"></i>;
    return (
      <div className="outerStack-mobile sm:outerStack">
        <div className="stepDescriptionText">Application Process</div>
        <div className="innerStack">
          <div className="text-left text-xl md:text-2xl">
            <div className="px-8 ml-10">
              <ol className="list-decimal">
                {displaySteps.map((s, i) => {
                  // verifyiddocs is always currentStep if it exists
                  const status =
                    s.key === "verifyiddocs"
                      ? currentStep
                      : firstIncomplete === i || s.key === "verifyiddocs"
                      ? uploadDocs
                        ? done
                        : currentStep
                      : p[s.key]
                      ? s.key === "confirm"
                        ? incomplete
                        : done
                      : incomplete;
                  return (
                    <li className={`${status}`}>
                      <div
                        className={`flex justify-between items-center ${status}`}
                      >
                        <span>{s.text}</span>
                        {firstIncomplete === i || s.key === "verifyiddocs" ? (
                          s.key === "confirm" ? (
                            check()
                          ) : !uploadDocsDone ? (
                            <></>
                          ) : (
                            check()
                          )
                        ) : p[s.key] ? (
                          check()
                        ) : (
                          <></>
                        )}
                      </div>
                    </li>
                  );
                })}
              </ol>
            </div>
          </div>
          {p.verifyPhone &&
          p.address &&
          p.personalInformation &&
          p.verifyId &&
          p.linkBank &&
          p.student ? (
            uploadDocs ? (
              uploadDocsDone ? (
                <div className={`text-xl mt-4`}>
                  All documents have been submitted.
                </div>
              ) : (
                <div className={`text-xl mt-4`}>
                  We need more information from you...
                </div>
              )
            ) : (
              <div className={`text-xl mt-4 font-black text-primary`}>
                You are ready to review and submit!
              </div>
            )
          ) : (
            <></>
          )}

          <div>
            <input
              type="button"
              name="button"
              value={
                p.verifyPhone &&
                p.address &&
                p.personalInformation &&
                p.verifyId &&
                p.linkBank &&
                p.student
                  ? uploadDocs && !uploadDocsDone
                    ? "Continue"
                    : "Review Your Application"
                  : "Resume Your Application"
              }
              onClick={() => {
                this.handleNext();
              }}
              className="continueButton cursor-pointer"
            />
          </div>
        </div>
      </div>
    );
  };

  renderSsnInput = () => {
    const { errorSSN } = this.state;
    const { user: { firstName, lastName } = {}, updateUser } = this.props;
    return (
      <div className="outerStack-mobile sm:outerStack">
        <div className="stepDescriptionText">
          {firstName && lastName
            ? `Hi ${firstName} ${lastName}!`
            : "Security Check"}
        </div>
        <div className="innerStack">
          <div className="py-4">
            <p className="pb-4 font-semibold text-lg">
              For security purposes, please re-enter your SSN:
            </p>
            <SSNInput
              onChange={ssn => {
                if (!ssn || ssn.length < 9) {
                  this.setState({
                    ssn: null,
                    errorSSN: "A valid SSN is required"
                  });
                  return false;
                } else {
                  this.setState({
                    errorSSN: null,
                    ssn
                  });
                }
              }}
              placeholder="XXX-XX-XXXX"
              className={`inputField inputFieldText mb-0 ${errorSSN &&
                "redBorder"}`}
              style={{ letterSpacing: "0.5ch" }}
            />
            <button
              disabled={!this.state.ssn}
              className={`continueButton ${(errorSSN || !this.state.ssn) &&
                "continueButtonLoading"}`}
              onClick={() => {
                updateUser({
                  ssn: this.state.ssn
                });
              }}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      renderEmailVerified,
      renderResumeApplication,
      handleNext
    } = this;
    const {
      applicationProgress,
    } = this.props;

    return (
      <div className="stepContainer">
        <div id="emailVerifiedContainer" className="innerStepContainer">
          <Header />

          {applicationProgress ? (
            applicationProgress.hasResumed == false ? (
              handleNext()
            ) : (
              renderResumeApplication()
            )
          ) : (
            renderEmailVerified()
          )}
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    user: state.register.user,
    step: state.register.resumeApplication,
    networkingError: state.register.networkingError,
    phoneNumberVerified: state.register.phoneNumberVerified,
    applicationProgress: state.register.applicationProgress,
    emailVerified: state.register.emailVerified
  }),
  actions
)(ResumeApplication);
